import {
  BaSeBreakpointContext,
  BaSeButton,
  BaSeContainer,
  BaSeDatePicker,
  BaSeErrorPage,
  BaSeGrid,
  BaSeGridItem,
  BaSeInput,
  BaSeLoadingSpinner,
  BaSeTheme,
} from '@base/react';
import React from 'react';
import { useCertificadoService } from '../../hooks/certificado';
import { Container, FormWrapper } from './dados-certificado-styled';
import moment from 'moment';
import {
  ErrorWrapper,
  LoadingWrapper,
} from '../visualizar-detalhe-erro/visualizar-detalhe-erro-styled';
import { dadosCertificadoDto } from '../../models/dados-certificado-dto';
const dateFormat = 'DD/MM/YYYY';

export const DadosCertificado = ({
  id,
  isShow,
  isUpdate,
  notify,
  save,
  onClose,
  // eslint-disable-next-line sonarjs/cognitive-complexity
}) => {
  const [result, loading, error] = useCertificadoService(id);
  const [loadingUpdate, setLoadingUpdate] = React.useState(false);
  const [idCertificado, setIdCertificado] = React.useState('');
  const [cpf, setCpf] = React.useState('');
  const [nomeCliente, setNomeCliente] = React.useState('');
  const [codigoSas, setCodigoSas] = React.useState('');
  const [produto, setProduto] = React.useState('');
  const [tipoSolucao, setTipoSolucao] = React.useState('');
  const [cargaHoraria, setCargaHoraria] = React.useState('');
  const [dataInicio, setDataInicio] = React.useState();
  const [dataFim, setDataFim] = React.useState();
  const [descricaoConteudo, setDescricaoConteudo] = React.useState('');
  const [composicaoConteudo, setComposicaoConteudo] = React.useState('');
  const { onTablet, onDesktop, onDesktopLarge } = React.useContext(
    BaSeBreakpointContext,
  );

  const isDesktop = React.useCallback(
    () => onTablet || onDesktop || onDesktopLarge,
    [onDesktop, onDesktopLarge, onTablet],
  );
  // eslint-disable-next-line sonarjs/cognitive-complexity
  React.useEffect(() => {
    let dateStart = moment(result?.dataInicio, dateFormat, true);
    let dateEnd = moment(result?.dataFim, dateFormat, true);

    setIdCertificado(result?.id ?? '');
    setCpf(result?.cpf ?? '');
    setNomeCliente(result?.nome ?? '');
    setCodigoSas(result?.idCurso ?? '');
    setProduto(result?.nomeCurso ?? '');
    setTipoSolucao(result?.tipoSolucao ?? '');
    setCargaHoraria(result?.cargaHoraria ?? '');
    setDataInicio(result?.dataInicio ? dateStart._d : undefined);
    setDataFim(result?.dataFim ? dateEnd._d : undefined);
    setDescricaoConteudo(result?.descricaoConteudo ?? '');
    setComposicaoConteudo(result?.composicaoConteudo?.toString() ?? '');
  }, [result]);

  const updateDadosCertificadoDTO = React.useCallback(() => {
    const dadosCertificado = { ...dadosCertificadoDto };
    const composicao = composicaoConteudo.trim();
    const toArrayComposicao = composicao.split(',')

    dadosCertificado.id = idCertificado;
    dadosCertificado.cpf = cpf.replace(/\D/g, '');
    dadosCertificado.nome = nomeCliente;
    dadosCertificado.idCurso = codigoSas;
    dadosCertificado.nomeCurso = produto;
    dadosCertificado.dataFim = new Intl.DateTimeFormat().format(dataFim);
    dadosCertificado.dataInicio = new Intl.DateTimeFormat().format(dataInicio);
    dadosCertificado.tipoSolucao = tipoSolucao;
    dadosCertificado.cargaHoraria = cargaHoraria;
    dadosCertificado.descricaoConteudo = descricaoConteudo.trim();
    dadosCertificado.composicaoConteudo = composicao !== '' ? toArrayComposicao : [];

    return dadosCertificado;
  }, [
    cargaHoraria,
    codigoSas,
    composicaoConteudo,
    cpf,
    dataFim,
    dataInicio,
    descricaoConteudo,
    idCertificado,
    nomeCliente,
    produto,
    tipoSolucao,
  ]);

  const handleSave = React.useCallback(async () => {
    setLoadingUpdate(true);
    const dto = updateDadosCertificadoDTO();
    const { sucess, message } = await save(dto);
    if (sucess) {
      notify({
        message: 'Dados salvos com sucesso!',
        color: 'confirmation',
      });
      setLoadingUpdate(false);
      return onClose?.closeModal?.();
    } else {
      notify({
        message,
        color: 'destructive',
      });
    }
    setLoadingUpdate(false);
  }, [updateDadosCertificadoDTO, save, notify, onClose]);

  const validForm = React.useCallback(() => {
    const descricao = descricaoConteudo.trim();
    const composicao = composicaoConteudo.trim();

    if (descricao !== '' && composicao === '') {
      notify({
        message:
          'O campo Composição do Conteúdo é de preenchimento obrigatório!',
        color: 'attention',
      });
    } else handleSave();
  }, [composicaoConteudo, descricaoConteudo, handleSave, notify]);

  return (
    <BaSeContainer delimitedOnBreakpoint="desktop">
      {loading && (
        <LoadingWrapper>
          <BaSeLoadingSpinner
            color="default"
            description="Carregando..."
            diameter={66}
            type="tertiary"
          />
        </LoadingWrapper>
      )}
      {error && (
        <ErrorWrapper>
          <BaSeErrorPage title="Algo deu errado" error="" />
        </ErrorWrapper>
      )}
      {!loading && !error && (
        <Container>
          <FormWrapper isDesktop={isDesktop()}>
            <BaSeInput
              isDisabled
              label="ID do certificado"
              onChange={(e) => setIdCertificado(e)}
              value={idCertificado}
            />
            <BaSeInput
              isDisabled={isShow}
              label="CPF do Cliente"
              mask="cpf"
              onChange={(e) => setCpf(e)}
              value={cpf}
            />
            <BaSeInput
              isDisabled={isShow}
              label="Nome do Cliente"
              onChange={(e) => setNomeCliente(e)}
              value={nomeCliente}
            />
            <BaSeGrid>
              <BaSeGridItem size={4}>
                <BaSeInput
                  isDisabled={isShow}
                  label="Código SAS"
                  onChange={(e) => setCodigoSas(e)}
                  value={codigoSas}
                />
              </BaSeGridItem>
              <BaSeGridItem size={8}>
                <BaSeInput
                  isDisabled={isShow}
                  label="Produto"
                  onChange={(e) => setProduto(e)}
                  value={produto}
                />
              </BaSeGridItem>
            </BaSeGrid>
            <BaSeGrid>
              <BaSeGridItem size={isDesktop() ? 3 : 6}>
                <BaSeInput
                  isDisabled={isShow}
                  label="Tipo de Solução"
                  onChange={(e) => setTipoSolucao(e)}
                  value={tipoSolucao}
                />
              </BaSeGridItem>
              <BaSeGridItem size={isDesktop() ? 3 : 6}>
                <BaSeInput
                  isDisabled={isShow}
                  label="Carga Horária"
                  onChange={(e) => setCargaHoraria(e)}
                  value={cargaHoraria}
                />
              </BaSeGridItem>
              <BaSeGridItem size={isDesktop() ? 3 : 6}>
                <BaSeDatePicker
                  isDisabled={isShow}
                  startDate={dataInicio}
                  onStartDateChange={(e) => setDataInicio(e)}
                  maxDate={dataFim}
                  label="Data Início"
                />
              </BaSeGridItem>
              <BaSeGridItem size={isDesktop() ? 3 : 6}>
                <BaSeDatePicker
                  isDisabled={isShow}
                  startDate={dataFim}
                  onStartDateChange={(e) => setDataFim(e)}
                  minDate={dataInicio}
                  maxDate={new Date()}
                  label="Data Fim"
                />
              </BaSeGridItem>
            </BaSeGrid>
            <BaSeInput
              isDisabled={isShow}
              label="Descrição do Conteúdo"
              onChange={(e) => setDescricaoConteudo(e)}
              value={descricaoConteudo}
            />
            <BaSeInput
              isDisabled={isShow}
              label="Composição do Conteúdo"
              onChange={(e) => setComposicaoConteudo(e)}
              value={composicaoConteudo}
            />
            {isUpdate && (
              <>
                <div style={{ marginTop: 20, display: 'flex', gap: 10 }}>
                  <BaSeButton
                    isLoading={loadingUpdate}
                    value="Salvar"
                    onClick={() => validForm()}
                  />
                  <BaSeButton
                    type="secondary"
                    color={BaSeTheme.colors.institucionais.azulSebrae36}
                    value="Cancelar"
                    onClick={() => onClose?.closeModal?.()}
                  />
                </div>
              </>
            )}
          </FormWrapper>
        </Container>
      )}
    </BaSeContainer>
  );
};
